import { css } from 'styled-components';

export const colors = css`

    // Base and Schibsted colors
    --color-black: #000000;
    --color-white: #FFFFFF;

    --color-blue-100: #020B23;
    --color-blue-90: #061A57;
    --color-blue-80: #0E2880;
    --color-blue-70: #1838A7;
    --color-blue-60: #264BC5;
    --color-blue-50: #4267D8;
    --color-blue-40: #6B8BE9;
    --color-blue-30: #97AFF4;
    --color-blue-20: #C7D5F9;
    --color-blue-10: #F5F7FE;

    --color-gray-100: #303130;
    --color-gray-90: #6B6B69;
    --color-gray-80: #959593;
    --color-gray-70: #B5B5B2;
    --color-gray-60: #D1CECC;
    --color-gray-50: #E4E4E1;
    --color-gray-40: #F2F0ED;
    --color-gray-30: #FAFAF7;
    --color-gray-20: #FEFDFB;
    --color-gray-10: #FFFFFF;

    // State colors
    --color-success-light: #EEFCED;
    --color-success-strong: #375F2B;

    --color-alert-light: #F5E0C0;
    --color-alert-strong: #6C4522;

    --color-info-light: var(--color-blue-20, #C7D5F9);
    --color-info-strong: var(--color-blue-60, #264BC5);

    --color-error-light: #FECFCD;
    --color-error-strong: #911515;

    --color-neutral-light: var(--color-gray-50, #E4E4E1);
    --color-neutral-strong: var(--color-gray-100, #303130);

    // Theme colors
    --color-primary: var(--color-blue-90);
    --color-secondary: var(--color-blue-100);
    /* --color-tertiary: var(--color-white); */ // Unused
    /* --color-quarternary: var(--color-blue-60); // Unused */

    --color-state-primary: rgba(38, 75, 197, 0.07);
    --color-state-secondary: rgba(38, 75, 197, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    // Typography colors
    --color-text-primary: var(--color-gray-100);
    --color-text-secondary: var(--color-gray-90);
    --color-text-tertiary: var(--color-gray-70);
    --color-text-contrast: var(--color-gray-10);

    --color-background-primary: var(--color-gray-10);
    --color-background-secondary: var(--color-gray-40);
    --color-background-tertiary: var(--color-gray-60);
    --color-background-contrast: var(--color-primary);

    --color-outline: var(--color-blue-60, #264BC5);
    --color-outline-accent: var(--color-blue-60);
`;
